// extracted by mini-css-extract-plugin
export default {"container":"useHandleTermsNotification__container--3EZ"};